import { render, staticRenderFns } from "./MessageTemplateSearchDropdown.vue?vue&type=template&id=4df8b7dd"
import script from "./MessageTemplateSearchDropdown.vue?vue&type=script&lang=js"
export * from "./MessageTemplateSearchDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports